import apiFeedbackTrainers from '@/api/feedback-trainers'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: null,
  lastPage: null,
}

export const mutationTypes = {
  getFeedbackTrainersStart: '[feedback trainers] Get feedback trainers start',
  getFeedbackTrainersSuccess:
    '[feedback trainers] Get feedback trainers success',
  getFeedbackTrainersFailure:
    '[feedback trainers] Get feedback trainers failure',
}

export const actionTypes = {
  getFeedbackTrainers: '[feedback trainers] Get trainer',
}

const mutations = {
  [mutationTypes.getFeedbackTrainersStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getFeedbackTrainersSuccess](state, payload) {
    if (payload.isAdd) {
      state.data = [...state.data, ...payload.list]
    } else {
      state.data = payload.list
    }

    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getFeedbackTrainersFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getFeedbackTrainers](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)
    context.commit(mutationTypes.getFeedbackTrainersStart)
    return new Promise((resolve) => {
      apiFeedbackTrainers
        .getFeedbackTrainersList(params)
        .then((response) => {
          context.commit(mutationTypes.getFeedbackTrainersSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getFeedbackTrainersFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
